import React, { useEffect, useState } from 'react';
import { api } from '../../api.js';
import { useI18n } from '../../i18n/index.jsx';
import { formatDate } from '../../format.js';

// "My account": changes the PME team made in the member's account (support,
// moderation). Hidden when there are none.
export default function TeamChanges() {
  const { t, lang } = useI18n();
  const [rows, setRows] = useState(null);
  useEffect(() => {
    let alive = true;
    api('/my/team-changes').then((r) => { if (alive) setRows(r); }).catch(() => { if (alive) setRows([]); });
    return () => { alive = false; };
  }, []);
  if (!rows?.length) return null;
  return (
    <section className="card team-changes">
      <h2 className="card-title">{t('teamChanges.title')}</h2>
      <p className="muted small">{t('teamChanges.lead')}</p>
      <ul>
        {rows.map((r, i) => (
          <li key={i}>
            <span className="team-changes-date">{formatDate(r.at, lang)}</span>
            <span>
              {t(`accessLog.entity.${r.entity}`)}{r.label ? ` « ${r.label} »` : ''}
              {r.action === 'updated' ? ` — ${t('teamChanges.fields', { n: r.fields.length })}` : ` — ${t(`accessLog.action.${r.action}`)}`}
              <span className="badge badge-team">{t('teamChanges.by')}</span>
            </span>
          </li>
        ))}
      </ul>
    </section>
  );
}
